export default __webpack_public_path__ + "static/media/Blade's Belt of the Hidden Tomb.a65120fc.jpg";